module.exports = {
  paymentType: "Payment Type",
  card: "Ingot / Card",
  gift: "Gift ",
  characterId: "Character ID",
  characterName: "Character Name",
  server: "Server",
  selectItem: "Select Item",
  confirmBtn: "Confirm",
  rechargeBtn: "Recharge ",
  inputRoleId: "Please confirm by enter your character ID",
  noRoleId: "Cannot find character ID, please reenter",
  supplementAllInfo: "Please fill in complete information ",
  errorCharacterId: "Character ID error",
  errorCharacterName: "Character ID cannot be empty",
  errorServer: "Server cannot be empty",
  errorSelectItem: "Selected item error",
  selectPayWay: "Please select your country and choose a payment method.",
  introduce:
    "About payment： <br>1. Yulgang Packs, Blessing Packs and Classic Packs can only be purchased once a day.<br>2. After fill in your character ID, please click 'comfirm' to confirm your character name and server name . After confirming your account correctness , you can complete your purchasing.<br>3. During the purchase if you have any quesiton or problem, Please contact our FB customer serviece. ：Yulgang Global.",
  code: {
    603: "User information does not exist ",
    606: "The item doesnot exist",
    607: "Payment gateway does not exist",
    605: "Exhange rate not yet set, please contact customer support ",
    608: "Character ID does not exist",
    609: "Order failed",
    610: "This server cannot be saved",
    611: "No characters are created in this server, please confirm login information",
    612: "The server does not exist",
    613: "Payment request",
    614: "Game notification failed",
    615: "The chracter ID does not exist"
  },
  rechargeSuccess: "Deposit success",
  pleaseCheck: "Reward has been sent, please enter the game to confirm",
  resultBtn: "Confirm",
  someQuestions:
    "If you have any problem while deposit, please contact customer service via Facebook   @YulgangGlobalID"
};
